// extracted by mini-css-extract-plugin
module.exports = {"topControls":"Report_topControls__1a7eZ","bottomControls":"Report_bottomControls__1azF6","email":"Report_email__186MP"};